import { setTask } from "./setTask";
import { setProgress } from "./setProgress";
import { setIsImporting } from "./setIsImporting";
import { setImportComplete } from "./setImportComplete";
import { setFileSize } from "./setFileSize";
import { reset } from "./reset";

export const reducers = { setTask, setProgress, setIsImporting, setImportComplete, setFileSize, reset };
